import * as React from 'react';
import { IModalProps, Modal } from 'office-ui-fabric-react/lib/Modal';
import { isOpx, getOpxHostApiForRender } from 'owa-opx';

export default function OwaModal(props: React.PropsWithChildren<IModalProps>) {
    React.useEffect(() => {
        if (isOpx()) {
            const opxHostApi = getOpxHostApiForRender();
            opxHostApi.modalOpened?.(true /* isOpened */);
            return () => opxHostApi.modalOpened?.(false /* isOpened */);
        }

        // If not opx, then don't do anything for cleanup
        return () => {};
    }, []);
    return (
        <Modal {...props} allowTouchBodyScroll={true}>
            {props.children}
        </Modal>
    );
}
